module.exports = __webpack_public_path__ + "img/air_freight.8768b756.svg";